export default __webpack_public_path__ + "static/media/Wanderlust1.c4ac7fe0.png";